<template>
	<div class="Customer">
		<common-body aside="2">
			<div slot="commonMain" class="list_box">
				<el-row type="flex" align="middle" justify="space-between" class="list_header">
					<el-row type="flex" align="middle" class="search_box">
						<el-input class="search_input" placeholder="搜索关键词" v-model="search"></el-input>
						<el-row type="flex" align="middle" justify="center" class="search_img">
							<img src="../assets/img/search.png" />
						</el-row>
						<div @click="searchList" class="search_btn"></div>
					</el-row>
					<el-row type="flex" align="middle" class="list_header_actions">
						<div
							v-if="isOwnCustomerTab && transferIncomingCount"
							@click="transferPanelVisible = true"
							class="list_add list_add--secondary">
							转移审批 ({{ transferIncomingCount }})
						</div>
						<div
							v-if="isOwnCustomerTab"
							@click="openShareManage"
							class="list_add list_add--secondary">
							共享管理
						</div>
						<div
							v-if="isOwnCustomerTab"
							@click="openShareDialog"
							class="list_add list_add--secondary">
							共享
						</div>
						<div v-if="isOwnCustomerTab && ruleList.customer_edit" @click="openBatchDiscountDialog" class="list_add list_add--secondary">统一折扣</div>
						<div v-if="isOwnCustomerTab && ruleList.customer_add" @click="addCustomer" class="list_add">新增客户</div>
					</el-row>
				</el-row>
				<el-tabs v-model="customerSourceTab" class="customer_source_tabs" @tab-click="onCustomerSourceTab">
					<el-tab-pane label="我的客户" name="mine"></el-tab-pane>
					<el-tab-pane
						v-for="s in incomingShares"
						:key="'share-' + s.owner_user_id"
						:label="s.peer_nickname || ('账号' + s.owner_user_id)"
						:name="'u-' + s.owner_user_id">
					</el-tab-pane>
				</el-tabs>
				<div v-if="!isOwnCustomerTab" class="customer_share_hint">
					当前为「{{ activeShareNickname }}」共享的客户，仅可查看与报价选用；可申请转移到自己账号。
				</div>
				<el-table
					ref="customerTable"
					:data="list"
					style="width: 100%"
					cell-class-name="good_text"
					header-cell-class-name="good_header"
					@selection-change="onCustomerSelectionChange">
					<el-table-column v-if="isOwnCustomerTab" type="selection" width="42" align="center" />
					<el-table-column align="center" min-width="3%" label="序号">
						<template slot-scope="scope">
							<div class="list_index">{{scope.$index+1}}</div>
						</template>
					</el-table-column>
					<el-table-column align="center" min-width="9%" prop="name" label="客户名称">
						<template slot-scope="scope">
							<span>{{ scope.row.name }}</span>
							<span v-if="!isOwnCustomerTab && scope.row.owner_nickname" class="customer_owner_tag">
								{{ scope.row.owner_nickname }}
							</span>
						</template>
					</el-table-column>
					<el-table-column align="center" min-width="8%" label="折扣率">
						<template slot-scope="scope">
							<span>{{ formatDiscount(scope.row.discount_rate) }}</span>
						</template>
					</el-table-column>
					<el-table-column align="center" min-width="10%" label="出样抵扣">
						<template slot-scope="scope">
							<span v-if="Number(scope.row.sample_deduct_amount) > 0">¥{{ Number(scope.row.sample_deduct_amount).toFixed(2) }} / {{ formatSampleRatio(scope.row.sample_deduct_ratio) }}</span>
							<span v-else>无</span>
						</template>
					</el-table-column>
					<el-table-column align="center" min-width="20%" prop="contact_address" label="联系地址">
					</el-table-column>
					<el-table-column align="center" min-width="8%" prop="contacts" label="联系人">
					</el-table-column>
					<el-table-column align="center" min-width="10%" prop="phone" label="手机号">
					</el-table-column>
					<el-table-column align="center" min-width="16%" label="备注">
						<template slot-scope="scope">
							<div>{{scope.row.remarks==""?"无":scope.row.remarks}}</div>
						</template>
					</el-table-column>
					<el-table-column align="center" min-width="8%" prop="createTime" label="录入时间">
					</el-table-column>
					<el-table-column align="center" width="208" label="操作" class-name="lq-action-col">
						<template slot-scope="scope">
							<!-- 我的客户：仅编辑/专属价/删除，绝不出现「申请转移」 -->
							<div v-if="isOwnCustomerTab" class="lq-row-actions list_set">
								<template v-if="ruleList.customer_see||ruleList.customer_edit||ruleList.customer_del">
									<el-tooltip v-if="ruleList.customer_edit" content="编辑" placement="top">
										<el-button type="text" icon="el-icon-edit" class="lq-row-action-btn" @click="editCustomer(scope.$index)" />
									</el-tooltip>
									<el-tooltip v-if="ruleList.customer_edit || ruleList.customer_see" content="出样抵扣" placement="top">
										<el-button type="text" icon="el-icon-s-ticket" class="lq-row-action-btn" @click="openSampleDialog(scope.$index)" />
									</el-tooltip>
									<el-tooltip v-if="ruleList.customer_edit || ruleList.customer_see" content="灯条专属价格设定" placement="top">
										<el-button type="text" icon="el-icon-price-tag" class="lq-row-action-btn" @click="openPriceDialog(scope.$index)" />
									</el-tooltip>
									<el-popconfirm v-if="ruleList.customer_del" @confirm="delCustomer(scope.$index)" confirmButtonType="danger" confirmButtonText="删除" title="确定删除该客户吗？">
										<el-tooltip content="删除" placement="top" slot="reference">
											<el-button type="text" icon="el-icon-delete" class="lq-row-action-btn lq-row-action-btn--danger" @click.stop />
										</el-tooltip>
									</el-popconfirm>
								</template>
								<span v-else>无</span>
							</div>
							<!-- 他人共享 Tab：只读 + 申请转移 -->
							<div v-else class="lq-row-actions list_set">
								<el-tooltip content="查看专属价" placement="top">
									<el-button type="text" icon="el-icon-price-tag" class="lq-row-action-btn" @click="openPriceDialog(scope.$index)" />
								</el-tooltip>
								<el-tooltip content="申请转移到我的账号" placement="top">
									<el-button type="text" icon="el-icon-sort" class="lq-row-action-btn" @click="applyTransfer(scope.row)" />
								</el-tooltip>
							</div>
						</template>
					</el-table-column>
				</el-table>
				<el-pagination class="good_page" :hide-on-single-page="pageSingle" @current-change="changePage" :page-size="limit"
				 prev-text="上一页" next-text="下一页" background layout="prev, pager, next" :total="listTotal">
				</el-pagination>
				<!-- 详情 / 编辑 / 新增 -->
				<el-dialog class="customer_dialog" top="5vh" :visible.sync="detailStatus" :append-to-body="true">
					<div class="detail_title" slot="title">{{formTitle}}</div>
					<el-form :rules="rules" ref='customerForm' label-position="right" :model="customerForm" class="detail_box">
						<el-form-item label="客户名称" prop="name">
							<el-input :class="{'detail_add':formStatus==3}" placeholder="请输入" :readonly="formRead" v-model="customerForm.name"></el-input>
						</el-form-item>
						<el-form-item label="联系地址" prop="contact_address">
							<el-input :class="{'detail_add':formStatus==3}" placeholder="请输入" :readonly="formRead" resize="none" type="textarea"
							 v-model="customerForm.contact_address"></el-input>
						</el-form-item>
						<el-form-item label="收货地址" prop="receiving_address">
							<el-input :class="{'detail_add':formStatus==3}" placeholder="请输入（不填写则默认联系地址）" :readonly="formRead" resize="none"
							 type="textarea" v-model="customerForm.receiving_address"></el-input>
						</el-form-item>
						<el-form-item label="联系人" prop="contacts">
							<el-input :class="{'detail_add':formStatus==3}" placeholder="请输入" :readonly="formRead" v-model="customerForm.contacts"></el-input>
						</el-form-item>
						<el-form-item label="手机号" prop="phone">
							<el-input :class="{'detail_add':formStatus==3}" placeholder="请输入" :readonly="formRead" v-model="customerForm.phone"></el-input>
						</el-form-item>
						<el-form-item label="传真" prop="fax">
							<el-input :class="{'detail_add':formStatus==3}" placeholder="请输入" :readonly="formRead" v-model="customerForm.fax"></el-input>
						</el-form-item>
						<el-form-item label="客户忠诚度">
							<el-select @change="changeLoyalty" class="list_type" :disabled="formRead" v-model="loyaltyIndex" placeholder="请选择">
								<el-option v-for="(item,index) in loyalty" :key="item.id" :label="item.name" :value="index">
								</el-option>
							</el-select>
						</el-form-item>
						<!-- 折扣率：统一用系数。1=原价，0.9=九折；专属价优先于折扣率 -->
						<el-form-item label="折扣率" prop="discount_rate">
							<el-input :class="{'detail_add':formStatus==3}" :readonly="formRead" v-model="customerForm.discount_rate"
							 placeholder="1=原价，0.9=九折"></el-input>
							<div class="field_hint">系数：默认 1（无折扣）；填 0.9 表示九折。报价有专属价时优先生效，否则乘本系数。</div>
						</el-form-item>
						<el-form-item label="备注" prop="remarks">
							<el-input :class="{'detail_add':formStatus==3}" placeholder="请输入" :readonly="formRead" resize="none" type="textarea"
							 v-model="customerForm.remarks"></el-input>
						</el-form-item>
						<el-form-item v-if="!formRead">
							<div class="detail_btn" @click="submitForm('customerForm')">确认</div>
						</el-form-item>
					</el-form>
				</el-dialog>

				<el-dialog class="customer_dialog sample_deduct_dialog" top="8vh" width="760px" :visible.sync="sampleDialogVisible"
					:append-to-body="true" :close-on-click-modal="false">
					<div class="detail_title" slot="title">出样抵扣 · {{ sampleCustomerName }}</div>
					<div class="sample_deduct_body">
						<div class="sample_deduct_fields">
							<div class="sample_deduct_field">
								<div class="sample_deduct_label">出样抵扣比例</div>
								<el-input :readonly="sampleRead" v-model="sampleForm.sample_deduct_ratio"
									placeholder="如 10，表示每单抵扣 10%"></el-input>
							</div>
							<div class="sample_deduct_field">
								<div class="sample_deduct_label">出样抵扣金额</div>
								<el-input :readonly="sampleRead" v-model="sampleForm.sample_deduct_amount"
									placeholder="默认等于关联订单合计，可修改"></el-input>
							</div>
						</div>
						<div class="field_hint">正式订单标为已付款时，按合同金额 × 比例从额度中抵扣。增删关联订单会按合同金额合计重填额度，之后仍可修改。已抵扣 ¥{{ sampleDeductUsed }}，剩余 ¥{{ sampleDeductRemain }}。</div>
						<div v-if="!sampleRead" class="sample_deduct_add">
							<el-select class="sample_order_select" v-model="samplePickId" filterable clearable placeholder="选择已下单的订单">
								<el-option v-for="item in sampleOrderCandidates" :key="item.id" :label="item.label" :value="item.id"></el-option>
							</el-select>
							<div class="sample_deduct_add_btn" @click="addSampleOrder">加入列表</div>
						</div>
						<el-table :data="sampleLinked" class="sample_order_table" empty-text="尚未关联出样订单">
							<el-table-column label="单号" min-width="140" prop="order_number"></el-table-column>
							<el-table-column label="联系人" min-width="90" prop="contacts"></el-table-column>
							<el-table-column label="合同金额" width="110" align="right">
								<template slot-scope="scope">¥{{ Number(scope.row.total || 0).toFixed(2) }}</template>
							</el-table-column>
							<el-table-column label="备注" min-width="180">
								<template slot-scope="scope">
									<el-input v-model="scope.row.remark" :readonly="sampleRead" size="small" placeholder="该订单的出样说明"></el-input>
								</template>
							</el-table-column>
							<el-table-column v-if="!sampleRead" label="操作" width="70" align="center">
								<template slot-scope="scope">
									<el-button type="text" class="lq-row-action-btn lq-row-action-btn--danger" @click="removeSampleOrder(scope.$index)">移除</el-button>
								</template>
							</el-table-column>
						</el-table>
						<div v-if="!sampleRead" class="sample_deduct_footer">
							<div class="detail_btn" @click="saveSampleDeduct">确认</div>
						</div>
					</div>
				</el-dialog>

				<!-- 统一折扣：应用到当前账号全部未删除客户 -->
				<el-dialog
					class="customer_dialog batch_discount_dialog"
					custom-class="batch_discount_panel"
					top="22vh"
					:visible.sync="batchDiscountVisible"
					:append-to-body="true"
					:close-on-click-modal="false"
					@close="onBatchDiscountClose">
					<div class="detail_title" slot="title">统一折扣</div>
					<div class="batch_discount_body">
						<p class="batch_discount_desc">应用到当前账号全部客户，覆盖原有折扣率；灯条专属价不变。</p>
						<el-form
							:model="batchDiscountForm"
							:rules="batchDiscountRules"
							ref="batchDiscountForm"
							class="batch_discount_form"
							@submit.native.prevent="submitBatchDiscount">
							<el-form-item label="折扣率" prop="discount_rate">
								<div class="batch_discount_field">
									<input
										class="batch_discount_input"
										v-model="batchDiscountForm.discount_rate"
										placeholder="0.9"
										inputmode="decimal"
										autocomplete="off"
										@keyup.enter="submitBatchDiscount"
									/>
									<span class="batch_discount_unit">系数</span>
								</div>
								<div class="batch_discount_presets">
									<span class="batch_discount_presets_label">常用</span>
									<button type="button" class="batch_discount_preset" @click="setBatchDiscount('1')">1 原价</button>
									<button type="button" class="batch_discount_preset" @click="setBatchDiscount('0.95')">0.95</button>
									<button type="button" class="batch_discount_preset" @click="setBatchDiscount('0.9')">0.9 九折</button>
								</div>
							</el-form-item>
						</el-form>
						<div class="batch_discount_footer">
							<button type="button" class="batch_discount_btn batch_discount_btn--ghost" @click="batchDiscountVisible = false">取消</button>
							<button
								type="button"
								class="batch_discount_btn batch_discount_btn--primary"
								:class="{'is-loading': batchDiscountSubmitting}"
								@click="submitBatchDiscount">确认应用</button>
						</div>
					</div>
				</el-dialog>

				<!-- 共享客户：两步（选客户 → 选目标账号） -->
				<el-dialog
					class="customer_dialog share_dialog"
					top="6vh"
					width="760px"
					:visible.sync="shareDialogVisible"
					:append-to-body="true"
					:close-on-click-modal="false"
					@closed="resetShareDialog">
					<div class="detail_title" slot="title">
						共享客户
						<span class="share_step_badge">第 {{ shareStep }} / 2 步</span>
					</div>
					<div class="share_dialog_body">
						<!-- 步骤1：搜索并勾选客户，加入共享列表 -->
						<div v-show="shareStep === 1">
							<div class="share_section">
								<el-checkbox v-model="shareAll" @change="onShareAllChange">
									共享我的全部客户（后续新建也自动共享）
								</el-checkbox>
							</div>
							<template v-if="!shareAll">
								<div class="share_section">
									<div class="share_section_title">搜索客户</div>
									<el-row type="flex" align="middle" class="share_search_row">
										<el-input
											v-model="shareCustomerSearch"
											clearable
											placeholder="客户名称 / 联系人 / 手机号"
											@keyup.enter.native="searchShareCustomers" />
										<el-button type="primary" :loading="shareCustomerLoading" @click="searchShareCustomers">搜索</el-button>
									</el-row>
								</div>
								<div class="share_section share_split">
									<div class="share_split_col">
										<div class="share_section_title">客户列表</div>
										<el-table
											ref="sharePickTable"
											:data="shareCustomerOptions"
											size="small"
											height="280"
											v-loading="shareCustomerLoading"
											@selection-change="onSharePickSelectionChange">
											<el-table-column type="selection" width="42" :selectable="sharePickSelectable" />
											<el-table-column prop="name" label="客户名称" min-width="110" show-overflow-tooltip />
											<el-table-column prop="contacts" label="联系人" width="90" show-overflow-tooltip />
											<el-table-column prop="phone" label="手机号" width="110" />
										</el-table>
										<div class="share_section_actions">
											<el-button size="mini" type="primary" plain :disabled="!sharePickSelection.length" @click="addSharePickedCustomers">
												加入共享列表
											</el-button>
										</div>
									</div>
									<div class="share_split_col">
										<div class="share_section_title">已加入共享（{{ shareSelectedCustomers.length }}）</div>
										<el-table :data="shareSelectedCustomers" size="small" height="280">
											<el-table-column prop="name" label="客户名称" min-width="110" show-overflow-tooltip />
											<el-table-column prop="phone" label="手机号" width="110" />
											<el-table-column label="" width="56" align="center">
												<template slot-scope="scope">
													<el-button type="text" class="lq-row-action-btn--danger" @click="removeShareSelectedCustomer(scope.$index)">移除</el-button>
												</template>
											</el-table-column>
										</el-table>
									</div>
								</div>
							</template>
							<div v-else class="share_all_tip">已选择持续共享全部客户，下一步选择接收账号即可。</div>
							<div class="share_dialog_footer">
								<el-button @click="shareDialogVisible = false">取消</el-button>
								<el-button type="primary" @click="goShareStep2">下一步</el-button>
							</div>
						</div>

						<!-- 步骤2：搜索并勾选目标账号 -->
						<div v-show="shareStep === 2">
							<div class="share_section">
								<div class="share_section_title">搜索目标账号（手机号 / 用户名）</div>
								<el-row type="flex" align="middle" class="share_search_row">
									<el-input
										v-model="shareUserKeyword"
										clearable
										placeholder="输入手机号或用户名搜索"
										@keyup.enter.native="searchShareUsers(shareUserKeyword)" />
									<el-button type="primary" :loading="shareUserLoading" @click="searchShareUsers(shareUserKeyword)">搜索</el-button>
								</el-row>
							</div>
							<div class="share_section share_split">
								<div class="share_split_col">
									<div class="share_section_title">搜索结果</div>
									<el-table
										ref="shareUserTable"
										:data="shareUserOptions"
										size="small"
										height="280"
										v-loading="shareUserLoading"
										@selection-change="onShareUserSelectionChange">
										<el-table-column type="selection" width="42" :selectable="shareUserSelectable" />
										<el-table-column label="昵称" min-width="100" show-overflow-tooltip>
											<template slot-scope="scope">{{ scope.row.nickname || scope.row.username }}</template>
										</el-table-column>
										<el-table-column prop="username" label="用户名" width="110" show-overflow-tooltip />
										<el-table-column prop="mobile" label="手机号" width="120" />
									</el-table>
									<div class="share_section_actions">
										<el-button size="mini" type="primary" plain :disabled="!shareUserPickSelection.length" @click="addSharePickedUsers">
											加入接收账号
										</el-button>
									</div>
								</div>
								<div class="share_split_col">
									<div class="share_section_title">已选接收账号（{{ shareSelectedUsers.length }}）</div>
									<el-table :data="shareSelectedUsers" size="small" height="280">
										<el-table-column label="昵称" min-width="100" show-overflow-tooltip>
											<template slot-scope="scope">{{ scope.row.nickname || scope.row.username }}</template>
										</el-table-column>
										<el-table-column prop="mobile" label="手机号" width="120" />
										<el-table-column label="" width="56" align="center">
											<template slot-scope="scope">
												<el-button type="text" class="lq-row-action-btn--danger" @click="removeShareSelectedUser(scope.$index)">移除</el-button>
											</template>
										</el-table-column>
									</el-table>
								</div>
							</div>
							<div class="share_summary">
								将共享：
								<strong v-if="shareAll">全部客户（持续）</strong>
								<strong v-else>{{ shareSelectedCustomers.length }} 位客户</strong>
								→
								<strong>{{ shareSelectedUsers.length }} 个账号</strong>
							</div>
							<div class="share_dialog_footer">
								<el-button @click="shareStep = 1">上一步</el-button>
								<el-button @click="shareDialogVisible = false">取消</el-button>
								<el-button type="primary" :loading="shareSubmitting" @click="submitShare">确定共享</el-button>
							</div>
						</div>
					</div>
				</el-dialog>

				<!-- 我发出的共享 -->
				<el-dialog
					class="customer_dialog"
					top="10vh"
					width="720px"
					:visible.sync="shareManageVisible"
					:append-to-body="true">
					<div class="detail_title" slot="title">共享管理</div>
					<el-table :data="outgoingShares" size="small" style="width:100%">
						<el-table-column label="接收账号" min-width="160">
							<template slot-scope="scope">
								{{ scope.row.peer_nickname || scope.row.peer_username }}
								<span class="customer_owner_tag">{{ scope.row.peer_mobile }}</span>
							</template>
						</el-table-column>
						<el-table-column label="范围" width="120" align="center">
							<template slot-scope="scope">
								{{ scope.row.share_all ? '全部（持续）' : ('指定 ' + (scope.row.customer_count || 0) + ' 人') }}
							</template>
						</el-table-column>
						<el-table-column label="操作" width="100" align="center">
							<template slot-scope="scope">
								<el-button type="text" class="lq-row-action-btn--danger" @click="cancelShare(scope.row)">取消共享</el-button>
							</template>
						</el-table-column>
					</el-table>
				</el-dialog>

				<!-- 转移审批 -->
				<el-dialog
					class="customer_dialog"
					top="10vh"
					width="720px"
					:visible.sync="transferPanelVisible"
					:append-to-body="true"
					@open="loadTransfers">
					<div class="detail_title" slot="title">客户转移审批</div>
					<div class="share_section_title">待我审批</div>
					<el-table :data="transferIncoming" size="small" style="width:100%;margin-bottom:16px">
						<el-table-column prop="customer_name" label="客户" min-width="120" />
						<el-table-column prop="to_nickname" label="申请人" width="120" />
						<el-table-column label="操作" width="160" align="center">
							<template slot-scope="scope">
								<el-button type="text" @click="decideTransfer(scope.row, true)">同意</el-button>
								<el-button type="text" class="lq-row-action-btn--danger" @click="decideTransfer(scope.row, false)">拒绝</el-button>
							</template>
						</el-table-column>
					</el-table>
					<div class="share_section_title">我发起的申请</div>
					<el-table :data="transferOutgoing" size="small" style="width:100%">
						<el-table-column prop="customer_name" label="客户" min-width="120" />
						<el-table-column prop="from_nickname" label="原账号" width="120" />
						<el-table-column prop="status" label="状态" width="100" align="center" />
					</el-table>
				</el-dialog>

				<!-- 灯条专属价格设定 -->
				<el-dialog
					class="customer_dialog price_dialog"
					custom-class="price_dialog_panel"
					top="6vh"
					:visible.sync="priceDialogVisible"
					:append-to-body="true"
					@close="onPriceDialogClose">
					<div class="price_dialog_title" slot="title">
						<div class="price_dialog_title_main">灯条专属价格</div>
						<div v-if="priceCustomerName" class="price_dialog_title_sub">{{ priceCustomerName }}</div>
					</div>
					<div class="price_panel">
						<div class="price_toolbar">
							<div class="price_toolbar_meta">
								<span class="price_meta_tag">型材线条灯</span>
								<span class="price_meta_text">专属价优先；「不参与折扣」按目录价且不乘客户折扣率</span>
							</div>
							<button
								v-if="canEditCustomerPrices"
								type="button"
								class="price_add_btn"
								@click="showPriceGood">
								<i class="el-icon-plus"></i>
								<span>从产品目录添加</span>
							</button>
						</div>
						<div class="price_table_wrap">
							<el-table
								:data="priceList"
								class="price_table"
								header-cell-class-name="price_th"
								cell-class-name="price_td"
								empty-text=" ">
								<template slot="empty">
									<div class="price_empty">
										<div class="price_empty_title">暂无设定</div>
										<div class="price_empty_text">{{ canEditCustomerPrices ? '点击上方从产品目录添加型材线条灯商品' : '暂未设定' }}</div>
									</div>
								</template>
								<el-table-column type="index" label="#" width="48" align="center"></el-table-column>
								<el-table-column prop="goods_name" label="商品" min-width="132" show-overflow-tooltip></el-table-column>
								<el-table-column prop="goods_model" label="型号" min-width="88" show-overflow-tooltip></el-table-column>
								<el-table-column prop="sku_text" label="规格" min-width="120" show-overflow-tooltip></el-table-column>
								<el-table-column label="目录价" width="88" align="right">
									<template slot-scope="scope">
										<span class="price_num price_num--muted">¥{{ scope.row.catalog_price }}</span>
									</template>
								</el-table-column>
								<el-table-column label="专属价" width="120" align="center">
									<template slot-scope="scope">
										<span v-if="scope.row.no_discount" class="price_num price_num--muted">目录价</span>
										<div v-else-if="canEditCustomerPrices" class="price_edit_cell">
											<span class="price_edit_prefix">¥</span>
											<input
												class="price_edit_input"
												v-model="scope.row._editPrice"
												inputmode="decimal"
												@blur="savePriceRow(scope.row)"
												@keyup.enter="$event.target.blur()"
											/>
										</div>
										<span v-else class="price_num price_num--strong">¥{{ scope.row.price }}</span>
									</template>
								</el-table-column>
								<el-table-column label="不参与折扣" width="100" align="center">
									<template slot-scope="scope">
										<el-switch
											v-if="canEditCustomerPrices"
											:value="!!scope.row.no_discount"
											@change="(on) => toggleNoDiscount(scope.row, on)" />
										<span v-else>{{ scope.row.no_discount ? '是' : '否' }}</span>
									</template>
								</el-table-column>
								<el-table-column v-if="canEditCustomerPrices" label="" width="56" align="center">
									<template slot-scope="scope">
										<el-popconfirm @confirm="delPriceRow(scope.row)" confirmButtonType="danger" confirmButtonText="删除" title="确定删除该设定？">
											<el-tooltip content="删除" placement="top" slot="reference">
												<el-button type="text" icon="el-icon-delete" class="price_row_del" @click.stop />
											</el-tooltip>
										</el-popconfirm>
									</template>
								</el-table-column>
							</el-table>
						</div>
					</div>
				</el-dialog>

				<!-- 专属价：产品目录（交互/样式对齐报价） -->
				<el-dialog
					class="good_dialog"
					custom-class="good_dialog_panel"
					:visible.sync="goodStatus"
					:show-close="false"
					:append-to-body="true"
					:close-on-click-modal="true">
					<div class="good_dialog_body">
						<el-row type="flex" align="middle" class="list_header">
							<el-row type="flex" align="middle" class="search_box">
								<el-input @keyup.enter.native="searchPriceGood" class="search_input" placeholder="搜索产品名称 / 关键词" v-model="goodSearch" clearable></el-input>
								<el-row type="flex" align="middle" justify="center" class="search_img">
									<img src="../assets/img/search.png" />
								</el-row>
								<div @click="searchPriceGood" class="search_btn" title="搜索"></div>
							</el-row>
							<span class="good_dialog_cat_fixed" title="专属价仅限该类目">{{ exclusiveCategoryName }}</span>
							<el-select @change="changePriceGoodType" class="list_type" v-model="goodTypeIndex" placeholder="子分类">
								<el-option v-for="(item,index) in goodTypes" :key="index" :label="item.name" :value="index">
								</el-option>
							</el-select>
							<button type="button" class="good_dialog_close" title="关闭" @click="goodStatus = false">
								<i class="el-icon-close"></i>
							</button>
						</el-row>
						<div class="good_list_wrap">
							<el-table highlight-current-row ref="priceGoodTable" @row-dblclick="choosePriceGood" @row-click="onPriceGoodRowClick" @current-change="selectPriceGood" :data="goodList"
							 class="good_list" cell-class-name="good_text" header-cell-class-name="good_header">
								<el-table-column :resizable="false" align="center" width="110" label="图片">
									<template slot-scope="scope">
										<el-row type="flex" justify="center" align="middle" class="good_img">
											<el-image fit="contain" :src="scope.row.image">
												<div slot="error" class="image-slot">
													<i class="el-icon-picture-outline"></i>
												</div>
											</el-image>
										</el-row>
									</template>
								</el-table-column>
								<el-table-column :resizable="false" align="center" min-width="40%" prop="name" label="产品名称" show-overflow-tooltip>
								</el-table-column>
								<el-table-column :resizable="false" header-align="center" align="left" min-width="48%" prop="summary" label="概述" show-overflow-tooltip>
								</el-table-column>
							</el-table>
						</div>
					</div>
				</el-dialog>

				<!-- 专属价：产品详情（左栏对齐报价；右栏设定专属价） -->
				<el-dialog class="cart_dialog price_cart_dialog" :visible.sync="priceCartStatus" top="4vh" :append-to-body="true">
					<div class="cart_title" slot="title">设定专属价</div>
					<div v-if="priceGood && priceCartStatus" class="cart_form">
						<el-row class="cart_body" type="flex">
							<div class="cart_good">
								<el-row type="flex" align="middle" class="cart_good_t">
									<el-row type="flex" justify="center" align="middle" v-if="skuActive===-1" class="cart_good_img">
										<el-image fit="contain" :src="priceGood.image">
											<div slot="error" class="image-slot">
												<i class="el-icon-picture-outline"></i>
											</div>
										</el-image>
									</el-row>
									<el-row type="flex" justify="center" align="middle" v-else class="cart_good_img">
										<el-image fit="contain" :src="priceGood.skuPrice[skuActive].image_url || priceGood.image">
											<div slot="error" class="image-slot">
												<i class="el-icon-picture-outline"></i>
											</div>
										</el-image>
									</el-row>
									<div class="cart_good_meta">
										<div class="cart_good_name">{{ priceGood.name }}</div>
										<div class="cart_good_tip">{{ skuActive===-1 ? (priceGood.summary || priceGood.model || '') : (priceGood.skuPrice[skuActive].sn || '') }}</div>
										<div class="cart_good_price">￥<span>{{ skuActive===-1 ? priceGood.price : priceGood.skuPrice[skuActive].price }}</span></div>
									</div>
								</el-row>
								<div v-if="priceGood.is_sku==1" class="cart_good_specs">
									<div class="cart_good_specs_box" v-for="(item,index) in priceGood.skuList" :key="index">
										<div class="cart_good_specs_name">{{ item.name }}</div>
										<el-row type="flex" class="cart_good_specs_content">
											<div @click="selectPriceSpec(idx,index)" class="cart_good_specs_item" :class="{'cart_good_specs_active': idx==item.activeIndex,'cart_good_specs_no': child.noStock}" v-for="(child,idx) in item.children" :key="idx">{{ child.name }}</div>
										</el-row>
									</div>
								</div>
								<div v-if="priceGood.parameterList && priceGood.parameterList.length" class="cart_good_params">
									<el-row type="flex" align="middle" class="cart_good_params_top">
										<div class="cart_good_params_title">产品参数</div>
										<div class="cart_good_params_tip">(<span>*</span>为必选项)</div>
									</el-row>
									<div
										class="cart_good_params_item"
										v-for="(item,index) in priceGood.parameterList"
										:key="'pp-'+index"
										v-if="shouldShowPriceParameterItem(item)">
										<el-row type="flex" class="cart_good_params_content">
											<div class="cart_good_params_name"><span v-if="item.must==1">*</span>{{ item.name }}</div>
											<div class="cart_good_params_fields">
												<template v-if="isNestedParam(item)">
													<el-select
														@change="selectPriceMidParam(index)"
														class="cart_good_params_select cart_good_params_select--mid"
														v-model="item.activeMidId"
														placeholder="请选择电压"
														popper-class="price-param-select-dropdown">
														<el-option
															v-for="mid in item.children"
															:key="'mid-'+mid.id"
															:label="mid.name"
															:value="mid.id" />
													</el-select>
													<el-select
														@change="selectPriceParam($event, index)"
														class="cart_good_params_select"
														v-model="item.activeId"
														:disabled="!item.activeMidId"
														placeholder="请选择色温"
														popper-class="price-param-select-dropdown">
														<el-option v-if="item.must!=1" :key="'leaf-empty-'+index" label="请选择" :value="''" />
														<el-option
															v-for="leaf in leafOptionsForMid(item, item.activeMidId)"
															:key="'leaf-'+leaf.id"
															:label="leaf.name"
															:value="leaf.id" />
													</el-select>
												</template>
												<template v-else>
													<el-select
														@change="(val) => selectPriceParam(val, index)"
														class="cart_good_params_select"
														v-model="item.activeId"
														placeholder="请选择"
														popper-class="price-param-select-dropdown">
														<el-option
															v-for="child in item.children"
															:key="'c-'+child.id"
															:label="child.name"
															:value="child.id" />
													</el-select>
												</template>
											</div>
										</el-row>
									</div>
								</div>
							</div>
							<div class="cart_data">
								<div class="cart_panel cart_panel--result">
									<div class="cart_data_title">价格信息</div>
									<el-row type="flex" class="cart_data_cal">
										<div>
											<el-row type="flex" align="middle" class="cart_data_cal_item">
												<div class="cart_data_cal_dot"></div>
												<div class="cart_data_cal_name">目录价：<span>{{ currentCatalogPrice !== '' ? currentCatalogPrice : '—' }}</span>元</div>
											</el-row>
											<el-row type="flex" align="middle" class="cart_data_cal_item">
												<div class="cart_data_cal_dot"></div>
												<div class="cart_data_cal_name">规格：<span>{{ currentSkuText }}</span></div>
											</el-row>
										</div>
									</el-row>
								</div>
								<div class="cart_panel">
									<div class="cart_data_title">设定方式</div>
									<button
										type="button"
										class="price_no_discount_btn"
										:class="{ 'is-active': exclusiveNoDiscount }"
										@click="toggleExclusiveNoDiscount">
										不参与折扣
									</button>
									<p class="price_exclusive_hint">开启后按实时目录价报价，不乘该客户折扣率。</p>
								</div>
								<div v-if="!exclusiveNoDiscount" class="cart_panel">
									<div class="cart_data_title">专属单价</div>
									<div class="price_exclusive_input_wrap">
										<span class="price_exclusive_prefix">￥</span>
										<input v-model="exclusivePriceInput" class="price_exclusive_input" placeholder="请输入专属单价" @input="onExclusivePriceInput" />
									</div>
									<p class="price_exclusive_hint">报价时优先使用专属价，不再乘折扣率。</p>
								</div>
								<div class="cart_panel">
									<el-row type="flex" justify="end" align="middle" class="cart_data_bottom">
										<div class="cart_btn" :class="{'is-loading': priceSubmitting}" @click="submitAddPrice">
											{{ exclusiveNoDiscount ? '确认添加' : '确认添加专属价' }}
										</div>
									</el-row>
								</div>
							</div>
						</el-row>
					</div>
				</el-dialog>
			</div>
		</common-body>
	</div>
</template>

<script>
	import {
		getT
	} from "../assets/js/public.js"
	import {
		isNestedParameter as isNestedParam,
		leafOptionsForMid,
		normalizeParameterList,
		onMidParameterChange,
		onLeafParameterChange,
		flatLeafParameterChange,
		syncSwitchParameterVisibility,
		shouldShowParameterItem as isParameterItemVisible,
	} from '@/utils/cart-parameter'

	/** 专属价可选商品根类目：按名称定位，接口筛选用其 id（当前库 id=2，无 code 字段） */
	const EXCLUSIVE_PRICE_CATEGORY_NAME = '型材线条灯'

	export default {
		name: 'Customer',
		data() {
			return {
				ruleList: JSON.parse(localStorage.getItem('ruleList') || '{}'),
				search: '',
				page: 1,
				pageSingle: !1,
				limit: 10,
				listTotal: 0,
				list: [],
				customerSourceTab: 'mine',
				incomingShares: [],
				outgoingShares: [],
				selectedCustomerIds: [],
				shareDialogVisible: !1,
				shareManageVisible: !1,
				shareStep: 1,
				shareAll: !1,
				shareCustomerSearch: '',
				shareCustomerOptions: [],
				shareCustomerLoading: !1,
				sharePickSelection: [],
				shareSelectedCustomers: [],
				shareUserKeyword: '',
				shareUserOptions: [],
				shareUserLoading: !1,
				shareUserPickSelection: [],
				shareSelectedUsers: [],
				shareSubmitting: !1,
				transferPanelVisible: !1,
				transferIncoming: [],
				transferOutgoing: [],
				detailStatus: !1,
				formRead: !1,
				formStatus: 1,
				formTitle: '',
				customerStatus: !1,
				loyalty: [],
				loyaltyIndex: 0,
				sampleDialogVisible: !1,
				sampleRead: !1,
				sampleSaving: !1,
				sampleCustomerName: '',
				samplePickId: '',
				sampleLinked: [],
				sampleOrderOptions: [],
				sampleDeductUsed: '0.00',
				sampleDeductRemain: '0.00',
				sampleForm: {
					id: 0,
					sample_deduct_ratio: '',
					sample_deduct_amount: ''
				},
				customerForm: {
					name: '',
					contact_address: '',
					receiving_address: '',
					contacts: '',
					phone: '',
					fax: '',
					loyal: '',
					discount_rate: '1',
					remarks: ''
				},
				rules: {
					name: [{
						required: true,
						message: '客户名称不能为空'
					}],
					contact_address: [{
						required: true,
						message: '联系地址不能为空'
					}],
					contacts: [{
						required: true,
						message: '联系人不能为空'
					}],
					phone: [{
						required: true,
						message: '手机号不能为空'
					}],
					discount_rate: [{
						validator: (rule, value, callback) => {
							if (value === '' || value == null) return callback(new Error('请填写折扣率'))
							const n = Number(value)
							if (!Number.isFinite(n) || n <= 0) return callback(new Error('折扣率须为大于 0 的系数'))
							if (n > 100) return callback(new Error('折扣率过大'))
							callback()
						},
						trigger: 'blur'
					}]
				},
				batchDiscountVisible: !1,
				batchDiscountSubmitting: !1,
				batchDiscountForm: {
					discount_rate: '1'
				},
				batchDiscountRules: {
					discount_rate: [{
						validator: (rule, value, callback) => {
							if (value === '' || value == null) return callback(new Error('请填写折扣率'))
							const n = Number(value)
							if (!Number.isFinite(n) || n <= 0) return callback(new Error('折扣率须为大于 0 的系数'))
							if (n > 100) return callback(new Error('折扣率过大'))
							callback()
						},
						trigger: 'blur'
					}]
				},
				priceDialogVisible: !1,
				priceCustomerId: 0,
				priceCustomerName: '',
				priceList: [],
				priceSubmitting: !1,
				/* 产品目录 / 详情（对齐报价 good_dialog + cart_dialog；仅型材线条灯） */
				goodStatus: !1,
				goodSearch: '',
				goodList: [],
				goodTypes: [{ id: '', name: '全部（型材线条灯）' }],
				goodTypeIndex: 0,
				exclusiveCategoryName: EXCLUSIVE_PRICE_CATEGORY_NAME,
				/** 型材线条灯根类目 id（按名称解析后写入；当前库为 2） */
				exclusivePriceCategoryId: 0,
				priceGood: null,
				priceCartStatus: !1,
				skuActive: -1,
				specIds: [],
				exclusivePriceInput: '',
				exclusiveNoDiscount: !1,
			}
		},
		computed: {
			isOwnCustomerTab() {
				return String(this.customerSourceTab || 'mine') === 'mine'
			},
			activeOwnerUserId() {
				if (this.isOwnCustomerTab) return 0
				const m = String(this.customerSourceTab || '').match(/^u-(\d+)$/)
				return m ? Number(m[1]) : 0
			},
			activeShareNickname() {
				const id = this.activeOwnerUserId
				const s = (this.incomingShares || []).find((x) => Number(x.owner_user_id) === id)
				return (s && (s.peer_nickname || s.peer_username)) || ''
			},
			transferIncomingCount() {
				return (this.transferIncoming || []).length
			},
			/** 仅「我的客户」可改专属价；共享 Tab 只读 */
			canEditCustomerPrices() {
				return !!(this.isOwnCustomerTab && this.ruleList && this.ruleList.customer_edit)
			},
			sampleOrderCandidates() {
				const linked = new Set((this.sampleLinked || []).map(function(item) { return Number(item.id) }))
				return (this.sampleOrderOptions || []).filter(function(item) {
					return !linked.has(Number(item.id))
				})
			},
			currentCatalogPrice() {
				const g = this.priceGood
				if (!g) return ''
				if (g.is_sku == 1) {
					if (this.skuActive < 0 || !g.skuPrice || !g.skuPrice[this.skuActive]) return ''
					return g.skuPrice[this.skuActive].price
				}
				return g.price
			},
			currentSkuText() {
				const g = this.priceGood
				if (!g) return '—'
				if (g.is_sku != 1) return '整品（无规格）'
				if (this.skuActive < 0 || !g.skuPrice || !g.skuPrice[this.skuActive]) return '请选择完整规格'
				const attrMap = {}
				;(g.skuList || []).forEach(function(root) {
					;(root.children || []).forEach(function(child) {
						attrMap[child.id] = (root.name ? root.name + ':' : '') + (child.name || '')
					})
				})
				const names = String(g.skuPrice[this.skuActive].goods_sku_ids || '').split(',').map(function(id) {
					return attrMap[parseInt(id, 10)] || id
				}).filter(Boolean)
				return names.length ? names.join(' / ') : ('SKU#' + g.skuPrice[this.skuActive].id)
			},
			currentSkuId() {
				const g = this.priceGood
				if (!g) return 0
				if (g.is_sku != 1) return 0
				if (this.skuActive < 0 || !g.skuPrice || !g.skuPrice[this.skuActive]) return null
				return g.skuPrice[this.skuActive].id
			}
		},
		created() {
			this.customerSourceTab = 'mine'
			this.reload()
		},
		methods: {
			formatDiscount(rate) {
				const n = Number(rate)
				if (!Number.isFinite(n)) return '1'
				return String(n)
			},
			openBatchDiscountDialog() {
				this.batchDiscountForm.discount_rate = '1'
				this.batchDiscountVisible = !0
				this.$nextTick(() => {
					if (this.$refs.batchDiscountForm) this.$refs.batchDiscountForm.clearValidate()
					const input = document.querySelector('.batch_discount_dialog .batch_discount_input')
					if (input) {
						input.focus()
						input.select()
					}
				})
			},
			onBatchDiscountClose() {
				this.batchDiscountSubmitting = !1
				this.batchDiscountForm.discount_rate = '1'
			},
			setBatchDiscount(rate) {
				this.batchDiscountForm.discount_rate = String(rate)
				this.$nextTick(() => {
					if (this.$refs.batchDiscountForm) this.$refs.batchDiscountForm.clearValidate()
				})
			},
			submitBatchDiscount() {
				const that = this
				if (that.batchDiscountSubmitting) return
				that.$refs.batchDiscountForm.validate((valid) => {
					if (!valid) return
					const rate = String(that.batchDiscountForm.discount_rate)
					that.$confirm(
						'确认将折扣率「' + rate + '」应用到当前账号下全部客户？将覆盖原有折扣率。',
						'统一折扣',
						{ confirmButtonText: '确认', cancelButtonText: '取消', type: 'warning' }
					).then(function() {
						that.batchDiscountSubmitting = !0
						that.$post('addons/hlm/api.Customer/setAllDiscountRate', {
							discount_rate: rate
						}).then(function(res) {
							that.batchDiscountSubmitting = !1
							if (res.code == 1) {
								const updated = res.data && res.data.updated != null ? res.data.updated : ''
								that.batchDiscountVisible = !1
								that.$message({
									message: updated !== '' ? ('已更新 ' + updated + ' 位客户的折扣率') : (res.msg || '更新成功'),
									type: 'success',
									duration: 1800,
									center: !0
								})
								that.getList()
							} else {
								that.$message({
									message: res.msg || '更新失败',
									type: 'warning',
									duration: 1800,
									center: !0
								})
							}
						}).catch(function(err) {
							console.log(err)
							that.batchDiscountSubmitting = !1
						})
					}).catch(function() {})
				})
			},
			reload() {
				let that = this
				that.loadIncomingShares()
				that.loadTransfers()
				that.getList()
				that.getLoyalty()
			},
			getLoyalty(e) {
				let that = this
				that.$fetch('addons/hlm/api.Customer/getLoyalList').then(function(res) {
					if (res.code == 1) {
						that.loyalty = res.data
					}
				}).catch(function(error) {
					console.log(error)
				})
			},
			loadIncomingShares() {
				const that = this
				that.$fetch('addons/hlm/api.Customer/shareListIncoming').then(function(res) {
					if (res.code == 1) {
						that.incomingShares = Array.isArray(res.data) ? res.data : []
						const still = that.customerSourceTab === 'mine'
							|| that.incomingShares.some((s) => ('u-' + s.owner_user_id) === that.customerSourceTab)
						if (!still) {
							that.customerSourceTab = 'mine'
							that.page = 1
							that.getList()
						}
					}
				}).catch(function() {})
			},
			loadTransfers() {
				const that = this
				that.$fetch('addons/hlm/api.Customer/transferList').then(function(res) {
					if (res.code == 1 && res.data) {
						that.transferIncoming = res.data.incoming || []
						that.transferOutgoing = res.data.outgoing || []
					}
				}).catch(function() {})
			},
			onCustomerSourceTab(tab) {
				// Element 可能传入 tab 对象；强制同步 name，避免落到错误 Tab
				const name = tab && (tab.name || (tab.$props && tab.$props.name))
				if (name != null && name !== '') this.customerSourceTab = String(name)
				if (!this.customerSourceTab) this.customerSourceTab = 'mine'
				this.page = 1
				this.selectedCustomerIds = []
				this.getList()
			},
			onCustomerSelectionChange(rows) {
				this.selectedCustomerIds = (rows || []).map((r) => r.id).filter(Boolean)
			},
			getList(e) {
				let that = this
				const params = {
					page: that.page,
					limit: that.limit,
					search: that.search
				}
				if (that.activeOwnerUserId) params.owner_user_id = that.activeOwnerUserId
				that.$fetch('addons/hlm/api.Customer/getCustomerList', params).then(function(res) {
					if (res.code == 1) {
						let list = res.data.list
						list.forEach((item) => {
							if (item.loyal && typeof item.loyal === 'object') {
								item.loyalName = item.loyal.name
								item.loyal = item.loyal.id
							} else {
								item.loyalName = ''
							}
							item.discount_rate = item.discount_rate != null ? String(item.discount_rate) : '1'
							item.createTime = item.createtime ? getT(item.createtime * 1000) : ''
						})
						that.list = list, that.listTotal = res.data.total
						that.selectedCustomerIds = []
					}
				}).catch(function(error) {
					console.log(error)
				})
			},
			changePage(e) {
				let that = this
				that.page = e, that.getList()
			},
			openShareDialog() {
				this.resetShareDialog()
				this.shareDialogVisible = !0
				this.searchShareCustomers()
			},
			resetShareDialog() {
				this.shareStep = 1
				this.shareAll = !1
				this.shareCustomerSearch = ''
				this.shareCustomerOptions = []
				this.shareCustomerLoading = !1
				this.sharePickSelection = []
				this.shareSelectedCustomers = []
				this.shareUserKeyword = ''
				this.shareUserOptions = []
				this.shareUserLoading = !1
				this.shareUserPickSelection = []
				this.shareSelectedUsers = []
				this.shareSubmitting = !1
				this.$nextTick(() => {
					if (this.$refs.sharePickTable) this.$refs.sharePickTable.clearSelection()
					if (this.$refs.shareUserTable) this.$refs.shareUserTable.clearSelection()
				})
			},
			onShareAllChange(val) {
				if (val) {
					this.sharePickSelection = []
					this.$nextTick(() => {
						if (this.$refs.sharePickTable) this.$refs.sharePickTable.clearSelection()
					})
				}
			},
			searchShareCustomers() {
				const that = this
				that.shareCustomerLoading = !0
				that.$fetch('addons/hlm/api.Customer/getCustomerList', {
					page: 1,
					limit: 100,
					search: String(that.shareCustomerSearch || '').trim(),
				}).then(function(res) {
					that.shareCustomerLoading = !1
					if (res.code == 1) {
						that.shareCustomerOptions = Array.isArray(res.data.list) ? res.data.list : []
					} else {
						that.shareCustomerOptions = []
					}
					that.$nextTick(() => {
						if (that.$refs.sharePickTable) that.$refs.sharePickTable.clearSelection()
						that.sharePickSelection = []
					})
				}).catch(function() {
					that.shareCustomerLoading = !1
					that.shareCustomerOptions = []
				})
			},
			onSharePickSelectionChange(rows) {
				this.sharePickSelection = rows || []
			},
			sharePickSelectable(row) {
				return !(this.shareSelectedCustomers || []).some((c) => String(c.id) === String(row.id))
			},
			addSharePickedCustomers() {
				const map = new Map((this.shareSelectedCustomers || []).map((c) => [String(c.id), c]))
				;(this.sharePickSelection || []).forEach((row) => {
					if (row && row.id != null) map.set(String(row.id), row)
				})
				this.shareSelectedCustomers = Array.from(map.values())
				this.$nextTick(() => {
					if (this.$refs.sharePickTable) this.$refs.sharePickTable.clearSelection()
					this.sharePickSelection = []
				})
				this.$message.success('已加入共享列表')
			},
			removeShareSelectedCustomer(index) {
				this.shareSelectedCustomers.splice(index, 1)
			},
			goShareStep2() {
				if (!this.shareAll && !this.shareSelectedCustomers.length) {
					this.$message.warning('请勾选客户并加入共享列表，或勾选共享全部客户')
					return
				}
				this.shareStep = 2
			},
			openShareManage() {
				const that = this
				that.$fetch('addons/hlm/api.Customer/shareListOutgoing').then(function(res) {
					if (res.code == 1) that.outgoingShares = Array.isArray(res.data) ? res.data : []
					that.shareManageVisible = !0
				})
			},
			searchShareUsers(keyword) {
				const that = this
				const q = String(keyword == null ? that.shareUserKeyword : keyword).trim()
				that.shareUserKeyword = q
				if (!q) {
					that.shareUserOptions = []
					return
				}
				that.shareUserLoading = !0
				that.$fetch('addons/hlm/api.Customer/searchUsers', { keyword: q, limit: 30 }).then(function(res) {
					that.shareUserLoading = !1
					if (res.code == 1) that.shareUserOptions = Array.isArray(res.data) ? res.data : []
					else that.shareUserOptions = []
					that.$nextTick(() => {
						if (that.$refs.shareUserTable) that.$refs.shareUserTable.clearSelection()
						that.shareUserPickSelection = []
					})
				}).catch(function() {
					that.shareUserLoading = !1
					that.shareUserOptions = []
				})
			},
			onShareUserSelectionChange(rows) {
				this.shareUserPickSelection = rows || []
			},
			shareUserSelectable(row) {
				return !(this.shareSelectedUsers || []).some((u) => String(u.id) === String(row.id))
			},
			addSharePickedUsers() {
				const map = new Map((this.shareSelectedUsers || []).map((u) => [String(u.id), u]))
				;(this.shareUserPickSelection || []).forEach((row) => {
					if (row && row.id != null) map.set(String(row.id), row)
				})
				this.shareSelectedUsers = Array.from(map.values())
				this.$nextTick(() => {
					if (this.$refs.shareUserTable) this.$refs.shareUserTable.clearSelection()
					this.shareUserPickSelection = []
				})
				this.$message.success('已加入接收账号')
			},
			removeShareSelectedUser(index) {
				this.shareSelectedUsers.splice(index, 1)
			},
			submitShare() {
				const that = this
				if (!that.shareSelectedUsers.length) {
					that.$message.warning('请搜索并勾选接收账号，加入列表后再确定')
					return
				}
				if (!that.shareAll && !that.shareSelectedCustomers.length) {
					that.$message.warning('请先选择要共享的客户')
					that.shareStep = 1
					return
				}
				that.shareSubmitting = !0
				that.$post('addons/hlm/api.Customer/shareCreate', {
					target_user_ids: that.shareSelectedUsers.map((u) => u.id),
					share_all: that.shareAll ? 1 : 0,
					customer_ids: that.shareAll ? [] : that.shareSelectedCustomers.map((c) => c.id),
				}).then(function(res) {
					that.shareSubmitting = !1
					if (res.code == 1) {
						that.shareDialogVisible = !1
						that.$message.success(res.msg || '共享成功')
					} else {
						that.$message.warning(res.msg || '共享失败')
					}
				}).catch(function() {
					that.shareSubmitting = !1
				})
			},
			cancelShare(row) {
				const that = this
				that.$confirm('取消后对方将无法再选用这些客户，已有订单不受影响。', '取消共享', {
					type: 'warning',
				}).then(function() {
					that.$post('addons/hlm/api.Customer/shareCancel', { id: row.id }).then(function(res) {
						if (res.code == 1) {
							that.$message.success('已取消共享')
							that.openShareManage()
						} else {
							that.$message.warning(res.msg || '操作失败')
						}
					})
				}).catch(function() {})
			},
			applyTransfer(row) {
				const that = this
				if (!row || !row.id) return
				if (that.isOwnCustomerTab) {
					that.$message.warning('自己的客户无需申请转移')
					return
				}
				that.$confirm('向「' + (row.owner_nickname || '原账号') + '」申请将客户「' + row.name + '」转移到您的账号？', '申请转移', {
					type: 'info',
				}).then(function() {
					that.$post('addons/hlm/api.Customer/transferApply', { customer_id: row.id }).then(function(res) {
						if (res.code == 1) {
							that.$message.success(res.msg || '已提交申请')
							that.loadTransfers()
						} else {
							that.$message.warning(res.msg || '提交失败')
						}
					})
				}).catch(function() {})
			},
			decideTransfer(row, approve) {
				const that = this
				const tip = approve
					? '同意后客户将归属申请人，对方获得完整编辑权限。'
					: '确定拒绝该转移申请？'
				that.$confirm(tip, approve ? '同意转移' : '拒绝转移', { type: approve ? 'warning' : 'info' }).then(function() {
					that.$post('addons/hlm/api.Customer/transferDecide', {
						id: row.id,
						approve: approve ? 1 : 0,
					}).then(function(res) {
						if (res.code == 1) {
							that.$message.success(res.msg || '已处理')
							that.loadTransfers()
							that.getList()
						} else {
							that.$message.warning(res.msg || '处理失败')
						}
					})
				}).catch(function() {})
			},
			formatSampleRatio(value) {
				const n = Number(value || 0)
				if (!n) return '0%'
				return (Number.isInteger(n) ? String(n) : String(n)) + '%'
			},
			editCustomer(e) {
				let that = this,
					customer = Object.assign({}, that.list[e]),
					loyalty = that.loyalty
				loyalty.forEach((item, index) => {
					if (item.id == customer.loyal) that.loyaltyIndex = index
				})
				if (customer.discount_rate == null || customer.discount_rate === '') customer.discount_rate = '1'
				that.detailStatus = !0, that.formRead = !1, that.formStatus = 2, that.formTitle = "编辑", that.customerForm =
					customer
			},
			openSampleDialog(e) {
				const row = this.list[e]
				if (!row) return
				this.sampleCustomerName = row.name || ''
				this.sampleRead = !this.ruleList.customer_edit
				this.sampleForm = {
					id: row.id,
					sample_deduct_ratio: '',
					sample_deduct_amount: ''
				}
				this.samplePickId = ''
				this.sampleLinked = []
				this.sampleOrderOptions = []
				this.sampleDeductUsed = '0.00'
				this.sampleDeductRemain = '0.00'
				this.sampleDialogVisible = !0
				this.loadSampleOrders(row.id)
			},
			addCustomer(e) {
				let that = this
				that.loyaltyIndex = 0
				that.detailStatus = !0, that.formRead = !1, that.formStatus = 3, that.formTitle = "新增客户"
				that.customerForm = {
					name: '',
					contact_address: '',
					receiving_address: '',
					contacts: '',
					phone: '',
					fax: '',
					loyal: that.loyalty[0] ? that.loyalty[0].id : 0,
					discount_rate: '1',
					remarks: ''
				}
			},
			delCustomer(e) {
				let that = this,
					id = that.list[e].id
				that.$fetch('addons/hlm/api.Customer/del', {
					id: id
				}).then(function(res) {
					if (res.code == 1) {
						that.detailStatus = !1, that.$message({
							message: '删除成功',
							type: 'success',
							duration: 1500,
							center: !0,
							onClose() {

							}
						}), that.getList()
					}
				}).catch(function(error) {
					console.log(error)
				})
			},
			loadSampleOrders(customerId) {
				let that = this
				if (!customerId) return
				that.$fetch('addons/hlm/api.Customer/getSampleOrderOptions', {
					customer_id: customerId
				}).then(function(res) {
					if (res.code != 1 || !res.data) return
					const orders = res.data.orders || []
					that.sampleOrderOptions = orders.map(function(item) {
						const total = Number(item.total || 0)
						return {
							id: Number(item.id),
							order_number: item.order_number,
							contacts: item.contacts || '',
							total: total,
							label: item.order_number + ' · ¥' + total.toFixed(2)
						}
					})
					that.sampleLinked = (res.data.linked || []).map(function(item) {
						return {
							id: Number(item.id),
							order_number: item.order_number,
							contacts: item.contacts || '',
							total: Number(item.total || 0),
							remark: item.remark || ''
						}
					})
					if (res.data.sample_deduct_amount != null) {
						that.sampleForm.sample_deduct_amount = String(res.data.sample_deduct_amount)
					}
					if (res.data.sample_deduct_ratio != null) {
						that.sampleForm.sample_deduct_ratio = String(res.data.sample_deduct_ratio)
					}
					that.sampleDeductUsed = Number(res.data.sample_deduct_used || 0).toFixed(2)
					that.sampleDeductRemain = Number(res.data.sample_deduct_remain || 0).toFixed(2)
				}).catch(function(error) {
					console.log(error)
				})
			},
			refreshSampleAmount() {
				let sum = 0
				this.sampleLinked.forEach(function(item) {
					sum += Number(item.total || 0)
				})
				this.sampleForm.sample_deduct_amount = (Math.round(sum * 100) / 100).toFixed(2)
			},
			addSampleOrder() {
				const id = Number(this.samplePickId)
				if (!id) {
					this.$message({ message: '请先选择订单', type: 'warning', duration: 1500, center: !0 })
					return
				}
				const found = this.sampleOrderOptions.find(function(item) { return Number(item.id) === id })
				if (!found) return
				if (this.sampleLinked.some(function(item) { return Number(item.id) === id })) return
				this.sampleLinked.push({
					id: found.id,
					order_number: found.order_number,
					contacts: found.contacts,
					total: found.total,
					remark: ''
				})
				this.samplePickId = ''
				this.refreshSampleAmount()
			},
			removeSampleOrder(index) {
				this.sampleLinked.splice(index, 1)
				this.refreshSampleAmount()
			},
			saveSampleDeduct() {
				let that = this
				if (that.sampleSaving || that.sampleRead) return
				const ratio = that.sampleForm.sample_deduct_ratio
				const amount = that.sampleForm.sample_deduct_amount
				const ratioNum = ratio === '' || ratio == null ? 0 : Number(ratio)
				const amountNum = amount === '' || amount == null ? 0 : Number(amount)
				if (!Number.isFinite(ratioNum) || ratioNum < 0 || ratioNum > 100) {
					that.$message({ message: '出样抵扣比例须为 0 到 100', type: 'warning', duration: 1500, center: !0 })
					return
				}
				if (!Number.isFinite(amountNum) || amountNum < 0) {
					that.$message({ message: '出样抵扣金额不能为负数', type: 'warning', duration: 1500, center: !0 })
					return
				}
				that.sampleSaving = !0
				that.$post('addons/hlm/api.Customer/edit', {
					id: that.sampleForm.id,
					sample_deduct_ratio: ratioNum,
					sample_deduct_amount: amountNum,
					sample_orders: JSON.stringify(that.sampleLinked.map(function(item) {
						return { id: item.id, remark: item.remark || '' }
					}))
				}).then(function(res) {
					that.sampleSaving = !1
					if (res.code == 1) {
						that.sampleDialogVisible = !1
						that.$message({ message: '出样抵扣已保存', type: 'success', duration: 1500, center: !0 })
						that.getList()
					}
				}).catch(function(error) {
					console.log(error)
					that.sampleSaving = !1
				})
			},
			changeLoyalty(e) {
				let that = this
				that.loyaltyIndex = e, that.customerForm.loyal = that.loyalty[e].id
			},
			searchList(e) {
				let that = this
				that.getList()
			},
			submitForm(customerForm) {
				let that = this
				if (that.customerStatus) return
				that.$refs[customerForm].validate((valid) => {
					if (valid) {
						that.customerStatus = !0
						const payload = Object.assign({}, that.customerForm)
						payload.discount_rate = String(payload.discount_rate == null || payload.discount_rate === '' ? 1 : payload.discount_rate)
						payload.id = that.customerForm.id
						if (that.formStatus == 2) {
							that.$post('addons/hlm/api.Customer/edit', {
								id: payload.id,
								name: payload.name,
								contacts: payload.contacts,
								phone: payload.phone,
								fax: payload.fax || '',
								contact_address: payload.contact_address,
								receiving_address: payload.receiving_address,
								remarks: payload.remarks || '',
								loyal: payload.loyal,
								discount_rate: payload.discount_rate
							}).then(function(res) {
								if (res.code == 1) {
									that.detailStatus = !1, that.$message({
										message: '编辑成功',
										type: 'success',
										duration: 1500,
										center: !0,
										onClose() {
											that.customerStatus = !1
										}
									}), that.getList()
								} else {
									that.customerStatus = !1
								}
							}).catch(function(error) {
								console.log(error)
								that.customerStatus = !1
							})
						} else if (that.formStatus == 3) {
							that.$post('addons/hlm/api.Customer/add', {
								name: payload.name,
								contacts: payload.contacts,
								phone: payload.phone,
								fax: payload.fax || '',
								contact_address: payload.contact_address,
								receiving_address: payload.receiving_address,
								remarks: payload.remarks || '',
								loyal: payload.loyal,
								discount_rate: payload.discount_rate
							}).then(function(res) {
								if (res.code == 1) {
									that.detailStatus = !1, that.$message({
										message: '新增成功',
										type: 'success',
										duration: 1500,
										center: !0,
										onClose() {
											that.customerStatus = !1
										}
									}), that.page = 1, that.getList()
								}else{
									that.customerStatus = !1
								}
							}).catch(function(error) {
								console.log(error)
								that.customerStatus = !1
							})
						}
					} else {
						console.log('error submit!!');
						return false;
					}
				});
			},
			openPriceDialog(index) {
				const row = this.list[index]
				if (!row) return
				this.priceCustomerId = row.id
				this.priceCustomerName = row.name
				this.priceDialogVisible = !0
				this.resetPricePickState()
				this.loadPriceList()
			},
			onPriceDialogClose() {
				this.priceCustomerId = 0
				this.priceList = []
				this.goodStatus = !1
				this.priceCartStatus = !1
				this.resetPricePickState()
			},
			resetPricePickState() {
				this.goodSearch = ''
				this.goodList = []
				this.goodTypeIndex = 0
				this.goodTypes = [{ id: '', name: '全部（型材线条灯）' }]
				this.priceGood = null
				this.skuActive = -1
				this.specIds = []
				this.exclusivePriceInput = ''
				this.exclusiveNoDiscount = !1
				this.priceCartStatus = !1
			},
			isNestedParam,
			leafOptionsForMid,
			shouldShowPriceParameterItem(item) {
				return isParameterItemVisible(item, this.priceGood, this.skuActive)
			},
			selectPriceMidParam(index) {
				const list = this.priceGood && this.priceGood.parameterList
				if (!list || !list[index]) return
				const item = onMidParameterChange(list[index], list[index].activeMidId)
				this.$set(list, index, { ...item })
			},
			selectPriceParam(val, index) {
				const list = this.priceGood && this.priceGood.parameterList
				if (!list || !list[index]) return
				const param = list[index]
				if (isNestedParam(param)) onLeafParameterChange(param, val)
				else flatLeafParameterChange(param, val)
				this.$set(list, index, { ...param })
			},
			toggleExclusiveNoDiscount() {
				this.exclusiveNoDiscount = !this.exclusiveNoDiscount
				if (this.exclusiveNoDiscount) this.syncExclusivePriceFromCatalog()
			},
			loadPriceList() {
				const that = this
				if (!that.priceCustomerId) return
				that.$fetch('addons/hlm/api.Customer/getGoodsPriceList', {
					customer_id: that.priceCustomerId
				}).then(function(res) {
					if (res.code == 1) {
						that.priceList = (res.data || []).map(function(row) {
							return Object.assign({}, row, {
								no_discount: !!row.no_discount,
								_editPrice: String(row.price),
							})
						})
					}
				}).catch(function(err) {
					console.log(err)
				})
			},
			/** 按名称解析「型材线条灯」根类目 id（库内无 code 字段；当前环境 id=2） */
			resolveExclusiveCategory() {
				const that = this
				if (that.exclusivePriceCategoryId > 0) return Promise.resolve(that.exclusivePriceCategoryId)
				return that.$fetch('addons/hlm/api.Goods/getCategory', {
					pid: 0
				}).then(function(res) {
					if (res.code != 1) return 0
					const list = res.data || []
					const hit = list.find(function(item) {
						return String(item.name || '').trim() === EXCLUSIVE_PRICE_CATEGORY_NAME
					})
					that.exclusivePriceCategoryId = hit ? Number(hit.id) : 0
					return that.exclusivePriceCategoryId
				}).catch(function(err) {
					console.log(err)
					return 0
				})
			},
			showPriceGood() {
				const that = this
				that.priceGood = null
				that.priceCartStatus = !1
				that.resolveExclusiveCategory().then(function(catId) {
					if (!catId) {
						that.$message({
							message: '未找到类目「' + EXCLUSIVE_PRICE_CATEGORY_NAME + '」，无法打开产品目录',
							type: 'warning',
							duration: 2000,
							center: !0
						})
						return
					}
					that.loadPriceGoodTypes()
					that.getPriceGoodList()
					that.goodStatus = !0
				})
			},
			loadPriceGoodTypes() {
				const that = this
				const rootId = that.exclusivePriceCategoryId
				if (!rootId) {
					that.goodTypes = [{ id: '', name: '全部（型材线条灯）' }]
					return
				}
				that.$fetch('addons/hlm/api.Goods/getCategory', {
					pid: rootId
				}).then(function(res) {
					const types = [{ id: '', name: '全部（型材线条灯）' }]
					if (res.code == 1) {
						that.goodTypes = types.concat(res.data || [])
					} else {
						that.goodTypes = types
					}
					if (that.goodTypeIndex >= that.goodTypes.length) that.goodTypeIndex = 0
				}).catch(function(err) {
					console.log(err)
					that.goodTypes = [{ id: '', name: '全部（型材线条灯）' }]
				})
			},
			getPriceGoodList() {
				const that = this
				const rootId = that.exclusivePriceCategoryId
				if (!rootId) {
					that.goodList = []
					return
				}
				const type = that.goodTypes[that.goodTypeIndex] || {}
				const params = {
					page: 1,
					limit: 999,
					search: that.goodSearch || '',
					pid: rootId
				}
				/* 选中子分类时按 category_id 精确筛；否则 pid=根类目，取该类目下全部商品 */
				if (type.id) {
					delete params.pid
					params.category_id = type.id
				}
				that.$fetch('addons/hlm/api.Goods/getGoodsList', params).then(function(res) {
					if (res.code == 1) {
						that.goodList = res.data.list || []
					}
				}).catch(function(err) {
					console.log(err)
				})
			},
			searchPriceGood() {
				this.goodList = []
				this.getPriceGoodList()
			},
			changePriceGoodType(e) {
				this.goodTypeIndex = e
				this.goodList = []
				this.getPriceGoodList()
			},
			selectPriceGood(e) {
				this.priceGood = e
			},
			onPriceGoodRowClick(row) {
				if (typeof window !== 'undefined' && window.innerWidth <= 768 && row) {
					this.choosePriceGood(row)
				}
			},
			choosePriceGood(e) {
				const that = this
				if (!e || !e.id) return
				that.$fetch('addons/hlm/api.Goods/getGoodsDetails', {
					goods_id: e.id
				}).then(function(res) {
					if (res.code != 1) return
					that.priceGood = res.data
					that.skuActive = -1
					that.specIds = []
					that.exclusivePriceInput = ''
					that.exclusiveNoDiscount = !1
					that.priceGood.parameterList = normalizeParameterList(that.priceGood.parameterList, null)
					// 先关产品目录，避免多层 dialog 压住参数下拉
					that.goodStatus = !1
					that.priceCartStatus = !0
					if (that.priceGood.is_sku == 1) {
						that.initPriceSkuSelection()
					} else {
						that.exclusivePriceInput = that.priceGood.price != null ? String(that.priceGood.price) : ''
					}
				}).catch(function(err) {
					console.log(err)
				})
			},
			initPriceSkuSelection() {
				const that = this
				;(that.priceGood.skuList || []).forEach(function(item) {
					item.activeId = ''
					item.activeIndex = -1
				})
				;(that.priceGood.skuPrice || []).forEach(function(price) {
					price.skuIds = String(price.goods_sku_ids || '').split(',')
				})
				that.setPriceStock()
				if (that.autoSelectSinglePriceSku()) that.setPriceStock()
				syncSwitchParameterVisibility(that, that.priceGood, that.skuActive)
				that.syncExclusivePriceFromCatalog()
			},
			autoSelectSinglePriceSku() {
				const list = this.priceGood && this.priceGood.skuList
				if (!list || !list.length) return false
				let changed = false
				list.forEach(function(item) {
					if (item.activeId) return
					const children = item.children || []
					const selectable = []
					children.forEach(function(child, idx) {
						if (!child.noStock) selectable.push({ child: child, idx: idx })
					})
					if (children.length === 1) {
						item.activeIndex = 0
						item.activeId = children[0].id
						changed = true
					} else if (selectable.length === 1) {
						item.activeIndex = selectable[0].idx
						item.activeId = selectable[0].child.id
						changed = true
					}
				})
				return changed
			},
			selectPriceSpec(idx, index) {
				const that = this
				if (that.priceGood.skuList[index].children[idx].noStock) return
				that.priceGood.skuList = that.priceGood.skuList.map(function(sku, indexS) {
					if (indexS === index) {
						if (sku.activeIndex === idx) {
							sku.activeIndex = -1
							sku.activeId = ''
						} else {
							sku.activeIndex = idx
							sku.activeId = sku.children[idx].id
						}
					}
					return sku
				})
				that.setPriceStock()
				that.syncExclusivePriceFromCatalog()
			},
			setPriceStock() {
				const that = this
				let isActive = !0
				that.specIds = []
				;(that.priceGood.skuList || []).forEach(function(item) {
					that.specIds.push(item.activeId)
				})
				const specIds = that.specIds.join(',')
				;(that.priceGood.skuPrice || []).forEach(function(price, indexP) {
					if (specIds === price.goods_sku_ids) {
						that.skuActive = indexP
						isActive = !1
					}
				})
				if (isActive) that.skuActive = -1
				syncSwitchParameterVisibility(that, that.priceGood, that.skuActive)
				;(that.priceGood.skuList || []).forEach(function(item, index) {
					;(item.children || []).forEach(function(child) {
						const ids = that.specIds.map(function(specId) { return specId })
						let num = 0
						ids[index] = child.id
						;(that.priceGood.skuPrice || []).forEach(function(price) {
							const skuIds = ids.map(function(spec, indexS) {
								if (spec === '') spec = price.skuIds[indexS]
								return spec
							})
							const skuIdText = skuIds.join(',')
							if (skuIdText === price.goods_sku_ids && (price.status == 'up' || price.status == 1 || price.status === '1' || !price.status)) num++
						})
						child.noStock = num === 0
					})
				})
			},
			syncExclusivePriceFromCatalog() {
				const cat = this.currentCatalogPrice
				this.exclusivePriceInput = cat !== '' && cat != null ? String(cat) : ''
			},
			onExclusivePriceInput() {
				this.exclusivePriceInput = String(this.exclusivePriceInput || '').replace(/[^\d.]/g, '')
			},
			submitAddPrice() {
				const that = this
				if (that.priceSubmitting) return
				if (!that.priceGood || !that.priceGood.id) {
					that.$message({ message: '请选择商品', type: 'warning', duration: 1500, center: !0 })
					return
				}
				if (that.priceGood.is_sku == 1 && (that.currentSkuId === null || that.currentSkuId === undefined)) {
					that.$message({ message: '请选择完整规格', type: 'warning', duration: 1500, center: !0 })
					return
				}
				const noDiscount = !!that.exclusiveNoDiscount
				let price = Number(that.exclusivePriceInput)
				if (noDiscount) {
					price = Number(that.currentCatalogPrice)
					if (!Number.isFinite(price) || price < 0) price = 0
				} else if (!Number.isFinite(price) || price < 0) {
					that.$message({ message: '请填写有效专属价', type: 'warning', duration: 1500, center: !0 })
					return
				}
				that.priceSubmitting = !0
				that.$post('addons/hlm/api.Customer/addGoodsPrice', {
					customer_id: that.priceCustomerId,
					goods_id: that.priceGood.id,
					sku_id: that.priceGood.is_sku == 1 ? that.currentSkuId : 0,
					price: price,
					no_discount: noDiscount ? 1 : 0,
				}).then(function(res) {
					that.priceSubmitting = !1
					if (res.code == 1) {
						that.$message({ message: '添加成功', type: 'success', duration: 1200, center: !0 })
						that.priceCartStatus = !1
						that.exclusivePriceInput = ''
						that.exclusiveNoDiscount = !1
						that.skuActive = -1
						that.loadPriceList()
					} else {
						that.$message({ message: res.msg || '添加失败', type: 'warning', duration: 1800, center: !0 })
					}
				}).catch(function(err) {
					console.log(err)
					that.priceSubmitting = !1
				})
			},
			savePriceRow(row) {
				const that = this
				if (row.no_discount) return
				const next = Number(row._editPrice)
				if (!Number.isFinite(next) || next < 0) {
					that.$message({ message: '价格无效', type: 'warning', duration: 1500, center: !0 })
					row._editPrice = String(row.price)
					return
				}
				if (Number(row.price) === next) return
				that.$post('addons/hlm/api.Customer/editGoodsPrice', {
					id: row.id,
					price: next,
					no_discount: 0,
				}).then(function(res) {
					if (res.code == 1) {
						row.price = next
						row.no_discount = !1
						that.$message({ message: '已更新', type: 'success', duration: 1000, center: !0 })
					} else {
						row._editPrice = String(row.price)
					}
				}).catch(function(err) {
					console.log(err)
					row._editPrice = String(row.price)
				})
			},
			toggleNoDiscount(row, on) {
				const that = this
				if (!row || !row.id) return
				that.$post('addons/hlm/api.Customer/editGoodsPrice', {
					id: row.id,
					no_discount: on ? 1 : 0,
				}).then(function(res) {
					if (res.code == 1) {
						row.no_discount = !!on
						that.$message({
							message: on ? '已设为不参与折扣' : '已取消不参与折扣',
							type: 'success',
							duration: 1000,
							center: !0,
						})
					} else {
						that.$message({ message: res.msg || '更新失败', type: 'warning', duration: 1500, center: !0 })
						that.loadPriceList()
					}
				}).catch(function(err) {
					console.log(err)
					that.loadPriceList()
				})
			},
			delPriceRow(row) {
				const that = this
				if (!row || !row.id) {
					that.$message({ message: '无法删除：缺少专属价 id', type: 'warning', duration: 1500, center: !0 })
					return
				}
				that.$fetch('addons/hlm/api.Customer/delGoodsPrice', {
					id: row.id
				}).then(function(res) {
					if (res.code == 1) {
						that.$message({ message: '已删除', type: 'success', duration: 1000, center: !0 })
						that.loadPriceList()
					} else {
						that.$message({ message: res.msg || '删除失败', type: 'warning', duration: 1800, center: !0 })
					}
				}).catch(function(err) {
					console.log(err)
					that.$message({ message: '删除失败', type: 'error', duration: 1500, center: !0 })
				})
			},
			re_phone(phone) {
				return /^(((13[0-9]{1})|(14[0-9]{1})|(15[0-9]{1})|(19[0-9]{1})|(18[0-9]{1})|(17[0-9]{1})|(16[0-9]{1}))+\d{8})$/.test(
					phone)
			}
		}
	};
</script>

<style src='../assets/css/customer.css'>
	/* px2rem能正常转换 */
</style>
